module.exports = __webpack_public_path__ + "cc7569b29c944be9246be8c439ff9da4.woff2";